export const SkeletonCell = () => <div className="skeleton-cell" />;
